const AUDIO_TYPES = ['audio/webm;codecs=opus', 'audio/webm', 'audio/ogg;codecs=opus', 'audio/mp4'];

/** First MediaRecorder audio type this browser supports (Safari → audio/mp4). */
export const getSupportedAudioMimeType = (): string | null => {
  if (typeof MediaRecorder === 'undefined') return null;
  return AUDIO_TYPES.find((type) => MediaRecorder.isTypeSupported(type)) ?? null;
};
